import { render, staticRenderFns } from "./EvaluationCriteriaList.vue?vue&type=template&id=46daeb2d"
import script from "./EvaluationCriteriaList.vue?vue&type=script&lang=js"
export * from "./EvaluationCriteriaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports